// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__xQuQ1j3eUS{width:100%;margin:0;padding-top:8px}.message-viewer-body__TyB7pE50y1{display:flex;margin:16px 0 0 -6px}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/messageIframe/messageIframe.module.scss"],"names":[],"mappings":"AAAA,uBACE,UAAA,CACA,QAAA,CACA,eAAA,CAGF,iCACE,YAAA,CACA,oBAAA","sourcesContent":[".container {\n  width: 100%;\n  margin: 0;\n  padding-top: 8px;\n}\n\n.message-viewer-body {\n  display: flex;\n  margin: 16px 0 0 -6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__xQuQ1j3eUS`,
	"message-viewer-body": `message-viewer-body__TyB7pE50y1`
};
export default ___CSS_LOADER_EXPORT___;
